import { OrderDoc, OrderStatusCode } from '@gooduncles/gu-app-schema';
import { useEffect, useState } from 'react';

import { observeOrders } from 'src/utils/firebase/firebase-short-cut';

interface UseRecentOrdersOptions {
  limit?: number;
}

export const useRecentOrders = (storeId: string | null, options: UseRecentOrdersOptions = {}) => {
  const { limit = 10 } = options;
  const [orders, setOrders] = useState<OrderDoc[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!storeId) {
      setOrders([]);
      return;
    }

    setIsLoading(true);

    const subscription = observeOrders(
      [
        ['storeId', '==', storeId],
        ['orderStatus', 'in', [OrderStatusCode.ACCEPTED, OrderStatusCode.DELIVERED]],
      ],
      {
        sortKey: 'date',
        orderBy: 'desc',
        limit,
      }
    ).subscribe({
      next: (orders) => {
        setOrders(orders);
        setIsLoading(false);
      },
      error: (err) => {
        console.error('Failed to fetch recent orders:', err);
        setIsLoading(false);
      },
    });

    return () => subscription.unsubscribe();
  }, [storeId, limit]);

  return { orders, isLoading };
};
